import DroneDenLogo from "./droneDenLogo.svg";

export default {
  DroneDenLogo,
};
